import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { LoginPage } from '@/features/auth/LoginPage';
import { RequireAuth } from '@/features/auth/RequireAuth';
import { RiskPage } from '@/features/admin/RiskPage';
import { StrategiesPage } from '@/features/admin/StrategiesPage';
import { UsersPage } from '@/features/admin/UsersPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { OperationsPage } from '@/features/ops/OperationsPage';
import { ControlsPage } from '@/features/controls/ControlsPage';
import { ReportsPage } from '@/features/reports/ReportsPage';
import { ApprovalsPage } from './features/approvals/ApprovalsPage';
import { OrdersPage } from './features/orders/OrdersPage';
import { PositionsPage } from './features/portfolio/PositionsPage';
import { ExchangesPage } from '@/features/exchanges/ExchangesPage';
import { ActivityPage } from '@/features/logs/ActivityPage';
import { AuditPage } from '@/features/logs/AuditPage';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { useAuth } from '@/stores/auth';
import { useUi } from '@/stores/ui';

export function App() {
  const bootstrap = useAuth((s) => s.bootstrap);
  const applyTheme = useUi((s) => s.applyTheme);

  useEffect(() => {
    applyTheme();
    void bootstrap();
  }, [bootstrap, applyTheme]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route index element={<DashboardPage />} />
          <Route path="positions" element={<PositionsPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="approvals" element={<ApprovalsPage />} />
          <Route path="operations" element={<OperationsPage />} />
          <Route path="controls" element={<ControlsPage />} />
          <Route path="exchanges" element={<ExchangesPage />} />
          <Route path="strategies" element={<StrategiesPage />} />
          <Route path="risk" element={<RiskPage />} />
          <Route path="people" element={<UsersPage />} />
          <Route path="activity" element={<ActivityPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
